import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3e0bd602"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "overlay"
};
var _hoisted_2 = {
  class: "popup",
  "data-cy": "sync-popup"
};
var _hoisted_3 = {
  class: "content-wrapper"
};
var _hoisted_4 = {
  class: "text-container"
};
var _hoisted_5 = {
  class: "title"
};
var _hoisted_6 = {
  class: "subtitle"
};
var _hoisted_7 = {
  class: "text-animation"
};
var _hoisted_8 = {
  class: "progress-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("sync.status.in-progress")), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.syncMessage), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: "progress-bar",
    style: _normalizeStyle({
      width: "".concat(_ctx.progress, "%")
    })
  }, null, 4)])])])])])) : _createCommentVNode("", true);
}